import Collection from '../../collection';
import Type from '../../model/newstype';

export default Collection.extend( {
	endpoint: 'types',
	responseAt: 'newstype',
    model: Type
} );


// WEBPACK FOOTER //
// ./src/js/collection/refbooks/types.js